export function fullName(user: { firstName?: string | null; lastName?: string | null }) {
  return [user.firstName, user.lastName].filter((x) => x).join(' ');
}
